/* lib/money.js — THE money formatter (2026-08-18 hardcode purge).
 *
 * The platform had FOUR independent formatters in TWO locales: the quote
 * modal printed "€ 1,234.56" (en-US) while the reports and the module editor
 * printed "€ 1.234,56" (de-DE) — two currency formats in one document trail.
 * One formatter, one locale (de-DE — the European convention the reports and
 * the module editor already used, matching the platform's market).
 */
const LOCALE = "de-DE";

/** "€ 1.234,56" — the standard 2-decimal money string. */
export function formatMoney(n) {
  return "€ " + Number(n || 0).toLocaleString(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** "€1.234" — compact form for dense tables (no forced decimals). */
export function formatMoneyShort(n) {
  return "€" + Number(n || 0).toLocaleString(LOCALE);
}
